export class LoanRequestsApi {
  #http;

  constructor(http) {
    this.#http = http;
  }

  async searchLoanRequestGroups(filter) {
    return this.#http.post('/api/loan-requests/search/grouped', filter);
  }

  async searchLoanRequests(filter) {
    return this.#http.post('/api/loan-requests/search', filter);
  }

  async getLoanRequest(id) {
    return this.#http.get(`/api/loan-requests/${id}`);
  }

  async getRequestContent(id) {
    return this.#http.get(`/api/loan-requests/${id}/request/content`, { responseType: 'blob' });
  }

  async getResponseContent(id) {
    return this.#http.get(`/api/loan-requests/${id}/response/content`, { responseType: 'blob' });
  }
}
